"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _request = require("@nicbase/request");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _nicbaseValidation = require("nicbase-validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TourDriverLinkDialog = function TourDriverLinkDialog(_ref) {
  var tour = _ref.tour,
      closeDialog = _ref.closeDialog;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var name = tour.name,
      token = tour.token,
      assetId = tour.assetId,
      _tour$dataRequest = tour.dataRequest,
      dataRequest = _tour$dataRequest === void 0 ? {} : _tour$dataRequest;

  var _useState = (0, _react.useState)(dataRequest.haulerEmail),
      _useState2 = _slicedToArray(_useState, 2),
      mailInput = _useState2[0],
      setMailInput = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showError = _useState4[0],
      setShowError = _useState4[1];

  var tourDriverLink = "".concat(ENV.tourDriverLinkUrl, "?token=").concat(token); // request to update the tour with the new mail

  var _useMutation = (0, _reactQuery.useMutation)(function (updatedTour) {
    return request({
      type: 'UPDATE_TOUR_FOR_TOUR_BOARD_REQUEST',
      headers: {
        version: 'v1',
        portalId: portalId
      },
      body: {
        tour: updatedTour
      }
    });
  }),
      updateTour = _useMutation.mutate,
      isLoadingUpdate = _useMutation.isLoading;

  var onSendClick = function onSendClick() {
    if ((0, _nicbaseValidation.kasasiEmailValidation)(mailInput)) {
      updateTour(_objectSpread(_objectSpread({}, tour), {}, {
        assetId: null,
        assetType: null,
        dataRequest: _objectSpread(_objectSpread({}, tour.dataRequest), {}, {
          haulerEmail: mailInput
        })
      }));
    } else {
      setShowError(true);
    }
  };

  var onMailInputChange = function onMailInputChange(newMail) {
    setMailInput(newMail);

    if (showError && (0, _nicbaseValidation.kasasiEmailValidation)(newMail)) {
      setShowError(false);
    }
  }; // add textarea for copy command and remove it afterwards


  var copyLinkToClipboard = function copyLinkToClipboard() {
    var textArea = document.createElement('textarea');
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    textArea.value = tourDriverLink;
    document.body.appendChild(textArea);
    textArea.select();
    textArea.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(textArea);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Body, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col text-base max-w-112"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xl font-bold text-primary mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.dataRequest"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.tour"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-1"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold mr-1"
    }, message, ":"), /*#__PURE__*/_react["default"].createElement("span", null, name));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    type: "email",
    value: mailInput,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.tourDriverLink.mailInput"
    }),
    error: showError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.tourDriverLink.mailError"
    }),
    onChange: onMailInputChange
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    raised: true,
    className: "mr-auto mb-4",
    onClick: onSendClick,
    disabled: showError || isLoadingUpdate
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.sendByMail"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "mr-auto underline text-blue-400",
    onClick: copyLinkToClipboard
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.copyLink"
  })), assetId && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col text-red-500 mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.assetWarning.title"
  })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink.assetWarning.text"
  }))))), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Footer, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    onClick: closeDialog
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.close"
  }))));
};

TourDriverLinkDialog.propTypes = {
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    token: _propTypes["default"].string,
    assetId: _propTypes["default"].number,
    dataRequest: _propTypes["default"].shape({
      haulerEmail: _propTypes["default"].string
    })
  }),
  closeDialog: _propTypes["default"].func
};

var noop = function noop() {};

TourDriverLinkDialog.defaultProps = {
  tour: {
    name: '',
    token: '',
    dataRequest: {},
    assetId: null
  },
  closeDialog: noop
};
var _default = TourDriverLinkDialog;
exports["default"] = _default;